import { getNumericMetric } from '@utils/metrics/rateMetrics';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import useTimeseriesQuery from '../useTimeseriesQuery';
import { globalOrderBySelector } from '@store/trends/base/selectors';
import { getPercentageMetricByKey } from '@src/utils/metrics/metricHelpers';

function useSecondaryQuery() {
  const metric = useSelector(globalOrderBySelector);
  const { query: baseQuery, ...rest }: any = useTimeseriesQuery();

  const query = useMemo(() => {
    const metrics = [...new Set([metric, getNumericMetric(metric)])];
    const percentageMetric = getPercentageMetricByKey({ metricKey: metric });
    if (percentageMetric) {
      metrics.push(percentageMetric);
    }
    return { ...baseQuery, metrics };
  }, [baseQuery, metric]);

  return { ...rest, query, metrics: query.metrics };
}

export default useSecondaryQuery;
